export const formatDate = (value) => value?.slice(0, 4);

export const analyseCasinos = (obj) => obj?.informational * obj?.game_review;

export const getGamblers = (obj) => obj?.default * obj?.operator_review;

export const getStart = (value) => {
    if (value > 300) return value - 200;
    return 0;
};